export default "__VITE_ASSET__va0XYhjx__"